export const capitalizeFirstLetter = ([first, ...rest]: string) =>
  [first.toUpperCase(), ...rest].join('');
